import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import API from '../utils/api';

const EMPTY = { name:'', phone:'', email:'', notes:'' };

export default function Suppliers() {
  const { user } = useAuth();
  const [suppliers, setSuppliers] = useState([]);
  const [search, setSearch] = useState('');
  const [modal, setModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [error, setError] = useState('');
  const [selected, setSelected] = useState(null); // المورد المختار لعرض تفاصيله
  const [details, setDetails] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [dateFrom, setDateFrom] = useState('');
  const [moveSearch, setMoveSearch] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [selectedMoves, setSelectedMoves] = useState(new Set());
  const [bulkSupplier, setBulkSupplier] = useState('');
  const [bulkLoading, setBulkLoading] = useState(false);
  const [mergeModal, setMergeModal] = useState(false);
  const [mergeSource, setMergeSource] = useState(null);
  const [mergeTarget, setMergeTarget] = useState('');

  const isAdmin = user?.role === 'admin';
  const isManager = ['admin','sales_manager'].includes(user?.role);

  const load = () => {
    API.get('/suppliers').then(r => setSuppliers(r.data)).catch(() => {});
  };
  useEffect(() => { load(); }, []);

  const filtered = suppliers.filter(s =>
    !search || s.name.toLowerCase().includes(search.toLowerCase()) ||
    (s.phone||'').includes(search)
  );

  const [updateMovements, setUpdateMovements] = useState(false);

  const save = async () => {
    if (!form.name?.trim()) return setError('اسم المورد مطلوب');
    try {
      if (editing) await API.put(`/suppliers/${editing}`, { ...form, update_movements: updateMovements });
      else await API.post('/suppliers', form);
      setModal(false); setEditing(null); setForm(EMPTY); setUpdateMovements(false);
      load();
      if (selected?.id === editing) {
        setSelected({ ...selected, name: form.name });
        loadDetails({ ...selected, name: form.name });
      }
    } catch(e) { setError(e.response?.data?.error || 'حدث خطأ'); }
  };

  const deleteSupplier = async (s) => {
    if (!window.confirm(`حذف المورد "${s.name}"؟`)) return;
    try {
      await API.delete(`/suppliers/${s.id}`);
      if (selected?.id === s.id) setSelected(null);
      load();
    } catch(e) { alert(e.response?.data?.error || 'حدث خطأ'); }
  };

  const printDetails = () => {
    if (!details?.movements?.length) return;
    const win = window.open('', '_blank', 'width=900,height=700');
    const today = new Date().toLocaleDateString('ar-SA');
    const rows = details.movements.map((m, i) => `
      <tr style="background:${i%2===0?'#fff':'#f0f4ff'}">
        <td style="text-align:center;font-weight:800;color:#6d28d9">${i+1}</td>
        <td style="font-size:12px;color:#475569">${new Date(m.created_at).toLocaleDateString('ar-SA')}</td>
        <td style="font-weight:700">${m.product_name||'-'}</td>
        <td style="font-size:12px;color:#475569">${[m.category_name,m.brand,m.size].filter(Boolean).join(' · ')||'-'}</td>
        <td style="text-align:center;font-weight:800;color:#16a34a">+${(m.quantity||0).toLocaleString()}</td>
        <td style="font-size:12px;color:#64748b">${m.invoice_number||'-'}</td>
      </tr>`).join('');
    win.document.write(`<!DOCTYPE html><html lang="ar" dir="rtl"><head><meta charset="utf-8"/>
      <title>سجل المورد — ${selected.name}</title>
      <style>
        *{margin:0;padding:0;box-sizing:border-box}
        body{font-family:Tahoma,Arial,sans-serif;direction:rtl;padding:24px;font-size:13px;color:#1e293b}
        .header{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:16px;padding-bottom:12px;border-bottom:2px solid #6d28d9}
        h2{font-size:18px;color:#6d28d9;margin-bottom:4px}.meta{font-size:12px;color:#64748b}
        .stats{display:flex;gap:12px;margin-bottom:16px}
        .stat{background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:8px 14px;text-align:center}
        .stat .num{font-size:16px;font-weight:800}.stat .lbl{font-size:11px;color:#64748b}
        table{width:100%;border-collapse:collapse}
        thead tr{background:#1e293b}th{color:white;padding:8px 10px;text-align:right;font-size:12px}
        td{padding:7px 10px;border-bottom:1px solid #e2e8f0;vertical-align:middle}
        @media print{@page{margin:1.2cm;size:A4 portrait}body{padding:0}-webkit-print-color-adjust:exact;print-color-adjust:exact}
      </style></head><body>
      <div class="header">
        <div><h2>🏭 سجل المورد — ${selected.name}</h2>
        <div class="meta">التاريخ: ${today}${dateFrom||dateTo?' | الفترة: '+(dateFrom||'')+(dateTo?' — '+dateTo:''):''}</div></div>
      </div>
      ${details.summary?`<div class="stats">
        <div class="stat"><div class="num" style="color:#16a34a">${(details.summary.total_qty||0).toLocaleString()}</div><div class="lbl">إجمالي الكميات</div></div>
        <div class="stat"><div class="num" style="color:#6d28d9">${details.summary.move_count||0}</div><div class="lbl">عدد التوريدات</div></div>
        <div class="stat"><div class="num" style="color:#0891b2">${details.summary.product_count||0}</div><div class="lbl">أنواع المواد</div></div>
      </div>`:''}
      <table><thead><tr><th style="width:36px;text-align:center">#</th><th>التاريخ</th><th>المادة</th><th>التصنيف/البراند/الحجم</th><th style="text-align:center">الكمية</th><th>رقم الفاتورة</th></tr></thead>
      <tbody>${rows}</tbody></table>
      </body></html>`);
    win.document.close();
    setTimeout(() => { win.focus(); win.print(); }, 400);
  };

  const exportExcel = () => {
    if (!details?.movements?.length) return;
    const header = ['#','التاريخ','المادة','التصنيف','البراند','الحجم','الكمية','رقم الفاتورة'];
    const rows = details.movements.map((m, i) => [
      i+1,
      new Date(m.created_at).toLocaleDateString('ar-SA'),
      m.product_name||'',
      m.category_name||'',
      m.brand||'',
      m.size||'',
      m.quantity||0,
      m.invoice_number||''
    ]);
    const csvContent = [header, ...rows].map(r => r.map(v => `"${v}"`).join(',')).join('\n');
    const blob = new Blob(['\uFEFF'+csvContent], { type:'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = `مورد_${selected.name}_${new Date().toISOString().slice(0,10)}.csv`;
    a.click(); URL.revokeObjectURL(url);
  };

  const toggleMoveSelect = (id) => {
    const n = new Set(selectedMoves);
    n.has(id) ? n.delete(id) : n.add(id);
    setSelectedMoves(n);
  };

  const toggleAllMoves = () => {
    if (selectedMoves.size === details?.movements?.length) setSelectedMoves(new Set());
    else setSelectedMoves(new Set(details.movements.map(m => m.id)));
  };

  const bulkUpdateSupplier = async () => {
    if (!selectedMoves.size || !bulkSupplier.trim()) return;
    if (!window.confirm(`تغيير المورد لـ ${selectedMoves.size} حركة إلى "${bulkSupplier}"؟`)) return;
    setBulkLoading(true);
    try {
      await API.put('/inventory/movements/bulk-supplier', { ids: [...selectedMoves], supplier: bulkSupplier });
      setSelectedMoves(new Set());
      setBulkSupplier('');
      loadDetails(selected);
    } catch(e) { alert(e.response?.data?.error || 'حدث خطأ'); }
    finally { setBulkLoading(false); }
  };

  const doMerge = async () => {
    if (!mergeSource || !mergeTarget) return;
    const target = suppliers.find(s => s.id === +mergeTarget);
    if (!window.confirm(`دمج "${mergeSource.name}" مع "${target?.name}"؟\nسيتم نقل كل حركات المخزون وحذف المورد الأول.`)) return;
    try {
      await API.post(`/suppliers/${mergeSource.id}/merge`, { target_id: +mergeTarget });
      setMergeModal(false);
      setMergeSource(null);
      setMergeTarget('');
      if (selected?.id === mergeSource.id) setSelected(null);
      load();
    } catch(e) { alert(e.response?.data?.error || 'حدث خطأ'); }
  };

  const visibleMoves = (details?.movements || []).filter(m =>
    !moveSearch ||
    (m.product_name || '').toLowerCase().includes(moveSearch.toLowerCase()) ||
    (m.invoice_number || '').toLowerCase().includes(moveSearch.toLowerCase())
  );

  const loadDetails = async (s) => {
    setSelected(s);
    setDetailsLoading(true);
    setDetails(null);
    setMoveSearch('');
    try {
      const params = new URLSearchParams();
      if (dateFrom) params.append('from', dateFrom);
      if (dateTo) params.append('to', dateTo);
      const r = await API.get(`/inventory/suppliers-summary?${params}`);
      const sup = r.data.find(x => x.supplier_requestor === s.name);
      // جلب حركات هذا المورد فقط — مفلترة بالتاريخ من السيرفر مباشرة (مش أول 500 حركة بكل النظام)
      const movParams = new URLSearchParams({ supplier: s.name });
      if (dateFrom) movParams.append('from', dateFrom);
      if (dateTo) movParams.append('to', dateTo);
      const movR = await API.get(`/inventory/movements?${movParams}`);
      const moves = movR.data.filter(m => m.movement_type === 'IN');
      setDetails({ summary: sup, movements: moves });
    } catch(e) { setDetails({ summary: null, movements: [] }); }
    finally { setDetailsLoading(false); }
  };

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">🏭 الموردون</h1>
        <div className="page-actions">
          {isManager && (
            <button className="btn btn-primary" onClick={() => { setEditing(null); setForm(EMPTY); setError(''); setModal(true); }}>
              + مورد جديد
            </button>
          )}
        </div>
      </div>

      <div style={{ display:'grid', gridTemplateColumns: selected ? '320px 1fr' : '1fr', gap:16 }}>

        {/* قائمة الموردين */}
        <div>
          <div className="search-bar" style={{ marginBottom:12 }}>
            <input className="search-input" placeholder="🔍 بحث بالاسم أو الهاتف..." value={search} onChange={e => setSearch(e.target.value)} />
          </div>

          <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
            {filtered.map(s => (
              <div key={s.id} onClick={() => loadDetails(s)}
                style={{
                  background: selected?.id === s.id ? '#ede9fe' : 'var(--surface)',
                  border: `1.5px solid ${selected?.id === s.id ? '#6d28d9' : 'var(--border)'}`,
                  borderRadius:10, padding:'12px 14px', cursor:'pointer', transition:'all 0.15s'
                }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                  <div>
                    <div style={{ fontWeight:700, fontSize:'0.9rem', color: selected?.id === s.id ? '#6d28d9' : 'var(--text)' }}>
                      🏭 {s.name}
                    </div>
                    {s.phone && <div style={{ fontSize:'0.78rem', color:'var(--muted)', marginTop:2 }}>📞 {s.phone}</div>}
                    {s.notes && <div style={{ fontSize:'0.75rem', color:'var(--muted)', marginTop:2 }}>📝 {s.notes}</div>}
                  </div>
                  {isManager && (
                    <div style={{ display:'flex', gap:4 }} onClick={e => e.stopPropagation()}>
                      <button className="btn btn-sm btn-secondary" onClick={() => { setEditing(s.id); setForm({ name:s.name, phone:s.phone||'', email:s.email||'', notes:s.notes||'' }); setError(''); setModal(true); }}>✏️</button>
                      {isAdmin && <button className="btn btn-sm" style={{background:'#f59e0b',color:'white',border:'none'}} onClick={() => { setMergeSource(s); setMergeTarget(''); setMergeModal(true); }} title="دمج مع مورد آخر">🔀</button>}
                      {isAdmin && <button className="btn btn-sm btn-danger" onClick={() => deleteSupplier(s)}>🗑️</button>}
                    </div>
                  )}
                </div>
              </div>
            ))}
            {filtered.length === 0 && (
              <div className="empty-state"><div className="empty-state-icon">🏭</div><p>لا يوجد موردون</p></div>
            )}
          </div>
        </div>

        {/* تفاصيل المورد */}
        {selected && (
          <div>
            <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:12, padding:16, marginBottom:16 }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:12 }}>
                <div>
                  <div style={{ fontWeight:800, fontSize:'1.1rem' }}>🏭 {selected.name}</div>
                  {selected.phone && <div style={{ fontSize:'0.82rem', color:'var(--muted)' }}>📞 {selected.phone}</div>}
                  {selected.email && <div style={{ fontSize:'0.82rem', color:'var(--muted)' }}>✉️ {selected.email}</div>}
                </div>
                <div style={{ display:'flex', gap:6 }}>
                  <button className="btn btn-sm btn-secondary" onClick={printDetails} title="طباعة A4">🖨️</button>
                  <button className="btn btn-sm btn-secondary" onClick={exportExcel} title="تصدير Excel">📊</button>
                  <button className="btn btn-sm btn-secondary" onClick={() => setSelected(null)}>✕</button>
                </div>
              </div>

              {/* فلتر التاريخ */}
              <div style={{ display:'flex', gap:8, alignItems:'center', flexWrap:'wrap' }}>
                <span style={{ fontSize:'0.82rem', color:'var(--muted)' }}>من:</span>
                <input type="date" value={dateFrom} onChange={e => setDateFrom(e.target.value)}
                  style={{ padding:'4px 8px', borderRadius:6, border:'1px solid var(--border)', fontSize:'0.82rem' }} />
                <span style={{ fontSize:'0.82rem', color:'var(--muted)' }}>إلى:</span>
                <input type="date" value={dateTo} onChange={e => setDateTo(e.target.value)}
                  style={{ padding:'4px 8px', borderRadius:6, border:'1px solid var(--border)', fontSize:'0.82rem' }} />
                <button className="btn btn-sm btn-primary" onClick={() => loadDetails(selected)}>🔍 تحديث</button>
                {(dateFrom||dateTo) && <button className="btn btn-sm btn-secondary" onClick={() => { setDateFrom(''); setDateTo(''); }}>✕</button>}
              </div>
            </div>

            {detailsLoading ? (
              <div className="loading"><div className="spinner"/></div>
            ) : details ? (<>
              {/* إحصائيات */}
              {details.summary && (
                <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:10, marginBottom:16 }}>
                  <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:10, padding:'12px 14px', textAlign:'center' }}>
                    <div style={{ fontSize:'1.4rem', fontWeight:800, color:'var(--success)' }}>{(details.summary.total_qty||0).toLocaleString()}</div>
                    <div style={{ fontSize:'0.75rem', color:'var(--muted)' }}>إجمالي الكميات</div>
                  </div>
                  <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:10, padding:'12px 14px', textAlign:'center' }}>
                    <div style={{ fontSize:'1.4rem', fontWeight:800, color:'var(--primary)' }}>{details.summary.move_count||0}</div>
                    <div style={{ fontSize:'0.75rem', color:'var(--muted)' }}>عدد التوريدات</div>
                  </div>
                  <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:10, padding:'12px 14px', textAlign:'center' }}>
                    <div style={{ fontSize:'1.4rem', fontWeight:800, color:'var(--info)' }}>{details.summary.product_count||0}</div>
                    <div style={{ fontSize:'0.75rem', color:'var(--muted)' }}>أنواع المواد</div>
                  </div>
                </div>
              )}

              {/* شريط التعديل الجماعي */}
              {selectedMoves.size > 0 && (
                <div style={{ background:'#4c1d95', borderRadius:10, padding:'10px 14px', marginBottom:10, display:'flex', alignItems:'center', gap:8, flexWrap:'wrap' }}>
                  <span style={{ color:'white', fontWeight:700, fontSize:'0.85rem' }}>✅ {selectedMoves.size} حركة محددة</span>
                  <select value={bulkSupplier} onChange={e => setBulkSupplier(e.target.value)}
                    style={{ padding:'5px 10px', borderRadius:6, border:'none', fontSize:'0.82rem', minWidth:160 }}>
                    <option value="">-- اختر المورد الجديد --</option>
                    {suppliers.map(s => <option key={s.id} value={s.name}>{s.name}</option>)}
                  </select>
                  <button className="btn btn-sm" onClick={bulkUpdateSupplier} disabled={bulkLoading||!bulkSupplier}
                    style={{ background:'#10b981', color:'white', border:'none' }}>
                    {bulkLoading ? '...' : '✔ تطبيق'}
                  </button>
                  <button className="btn btn-sm" onClick={() => { setSelectedMoves(new Set()); setBulkSupplier(''); }}
                    style={{ background:'rgba(255,255,255,0.2)', color:'white', border:'none' }}>إلغاء</button>
                </div>
              )}

              {/* جدول الحركات */}
              <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:12, overflow:'hidden' }}>
                <div style={{ padding:'12px 16px', borderBottom:'1px solid var(--border)', display:'flex', justifyContent:'space-between', alignItems:'center', gap:10, flexWrap:'wrap' }}>
                  <span style={{ fontWeight:700, fontSize:'0.9rem' }}>
                    📦 سجل التوريدات ({visibleMoves.length}{moveSearch ? ` من ${details.movements.length}` : ''})
                  </span>
                  <input
                    value={moveSearch}
                    onChange={e => setMoveSearch(e.target.value)}
                    placeholder="🔍 بحث بالمادة أو رقم الفاتورة..."
                    style={{ padding:'6px 10px', borderRadius:6, border:'1px solid var(--border)', fontSize:'0.82rem', minWidth:220 }} />
                </div>
                <div className="table-scroll">
                  <table>
                    <thead>
                      <tr>
                        <th style={{width:36,textAlign:'center'}}>
                          <div onClick={toggleAllMoves} style={{width:16,height:16,borderRadius:3,border:`2px solid ${selectedMoves.size===details?.movements?.length&&details?.movements?.length>0?'#fff':'rgba(255,255,255,0.5)'}`,background:selectedMoves.size===details?.movements?.length&&details?.movements?.length>0?'white':'transparent',display:'inline-flex',alignItems:'center',justifyContent:'center',cursor:'pointer'}}>
                            {selectedMoves.size===details?.movements?.length&&details?.movements?.length>0&&<span style={{color:'#6d28d9',fontSize:10,fontWeight:900}}>✓</span>}
                          </div>
                        </th>
                        <th>التاريخ</th>
                        <th>المادة</th>
                        <th>التصنيف</th>
                        <th style={{textAlign:'center'}}>الكمية</th>
                        <th>رقم الفاتورة</th>
                      </tr>
                    </thead>
                    <tbody>
                      {visibleMoves.length === 0 ? (
                        <tr><td colSpan={6} className="text-center text-muted" style={{padding:24}}>لا توجد حركات</td></tr>
                      ) : visibleMoves.map(m => (
                        <tr key={m.id} style={{background:selectedMoves.has(m.id)?'#ede9fe':undefined}}>
                          <td style={{textAlign:'center'}}>
                            <div onClick={()=>toggleMoveSelect(m.id)} style={{width:16,height:16,borderRadius:3,border:`2px solid ${selectedMoves.has(m.id)?'#6d28d9':'#d1d5db'}`,background:selectedMoves.has(m.id)?'#6d28d9':'white',display:'inline-flex',alignItems:'center',justifyContent:'center',cursor:'pointer'}}>
                              {selectedMoves.has(m.id)&&<span style={{color:'white',fontSize:10,fontWeight:900}}>✓</span>}
                            </div>
                          </td>
                          <td style={{ fontSize:'0.82rem', color:'var(--muted)' }}>
                            {new Date(m.created_at).toLocaleDateString('ar-SA')}
                          </td>
                          <td>
                            <div style={{ fontWeight:700, fontSize:'0.85rem' }}>{m.product_name}</div>
                            <div style={{ fontSize:'0.75rem', color:'var(--muted)' }}>
                              {[m.category_name, m.brand, m.size].filter(Boolean).join(' · ')}
                            </div>
                          </td>
                          <td><span className="badge badge-info" style={{fontSize:'0.72rem'}}>{m.category_name||'-'}</span></td>
                          <td style={{ textAlign:'center', fontWeight:700, color:'var(--success)' }}>+{m.quantity?.toLocaleString()}</td>
                          <td style={{ fontSize:'0.82rem', color:'var(--muted)' }}>{m.invoice_number||'-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </>) : null}
          </div>
        )}
      </div>

      {/* مودال الدمج */}
      {mergeModal && mergeSource && (
        <div className="modal-overlay" onClick={() => setMergeModal(false)}>
          <div className="modal" style={{ maxWidth:440 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <span className="modal-title">🔀 دمج مورد</span>
              <button className="modal-close" onClick={() => setMergeModal(false)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="alert alert-warning" style={{ marginBottom:14, background:'#fef3c7', border:'1px solid #fcd34d', borderRadius:8, padding:'10px 14px', fontSize:'0.85rem', color:'#92400e' }}>
                ⚠️ سيتم نقل كل حركات المخزون من <strong>"{mergeSource.name}"</strong> إلى المورد الذي تختاره، ثم حذف المورد الأول نهائياً.
              </div>
              <div className="form-group">
                <label>دمج <strong>{mergeSource.name}</strong> مع:</label>
                <select value={mergeTarget} onChange={e => setMergeTarget(e.target.value)}>
                  <option value="">-- اختر المورد الهدف --</option>
                  {suppliers.filter(s => s.id !== mergeSource.id).map(s => (
                    <option key={s.id} value={s.id}>{s.name}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-primary" onClick={doMerge} disabled={!mergeTarget}
                style={{ background:'#f59e0b', borderColor:'#f59e0b' }}>🔀 دمج الآن</button>
              <button className="btn btn-secondary" onClick={() => setMergeModal(false)}>إلغاء</button>
            </div>
          </div>
        </div>
      )}

      {/* مودال الإضافة/التعديل */}
      {modal && (
        <div className="modal-overlay" onClick={() => setModal(false)}>
          <div className="modal" style={{ maxWidth:480 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <span className="modal-title">{editing ? 'تعديل مورد' : 'مورد جديد'}</span>
              <button className="modal-close" onClick={() => setModal(false)}>✕</button>
            </div>
            <div className="modal-body">
              {error && <div className="alert alert-error">{error}</div>}
              <div className="form-grid">
                <div className="form-group span-2">
                  <label>اسم المورد <span style={{color:'var(--danger)'}}>*</span></label>
                  <input value={form.name} onChange={e => setForm({...form, name:e.target.value})} placeholder="NAR ETIKET..." />
                </div>
                <div className="form-group">
                  <label>الهاتف</label>
                  <input value={form.phone} onChange={e => setForm({...form, phone:e.target.value})} placeholder="+90..." />
                </div>
                <div className="form-group">
                  <label>البريد الإلكتروني</label>
                  <input value={form.email} onChange={e => setForm({...form, email:e.target.value})} placeholder="info@..." />
                </div>
                <div className="form-group span-2">
                  <label>ملاحظات</label>
                  <input value={form.notes} onChange={e => setForm({...form, notes:e.target.value})} placeholder="أي معلومات إضافية..." />
                </div>
                {editing && (
                  <div className="form-group span-2">
                    <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer', fontWeight:400 }}>
                      <div onClick={()=>setUpdateMovements(!updateMovements)} style={{width:18,height:18,borderRadius:4,border:`2px solid ${updateMovements?'#6d28d9':'#d1d5db'}`,background:updateMovements?'#6d28d9':'white',display:'inline-flex',alignItems:'center',justifyContent:'center',cursor:'pointer',flexShrink:0}}>
                        {updateMovements&&<span style={{color:'white',fontSize:12,fontWeight:900}}>✓</span>}
                      </div>
                      تحديث اسم المورد في حركات المخزون القديمة تلقائياً
                    </label>
                  </div>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-primary" onClick={save}>💾 حفظ</button>
              <button className="btn btn-secondary" onClick={() => setModal(false)}>إلغاء</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
